import React from 'react';
import Popup from '../Popup/Popup';

interface ProfilePopupProps {
  isOpen: boolean;
  onClose: () => void;
  name: string;
  email: string;
  onResetPassword: () => void;
}

const ProfilePopup: React.FC<ProfilePopupProps> = ({
  isOpen,
  onClose,
  name,
  email,
  onResetPassword
}) => {
  if (!isOpen) return null;

  return (
    <Popup width="35vw" onClose={onClose}>
      <h2 className="contact-title">My Profile</h2>
      <div className="profile-content">
        <div className="profile-info">
          <h3 style={{ textTransform: 'capitalize' }}>{name}</h3>
          <p className="email">{email}</p>
        </div>
        <button
          className="btn btn-reset"
          onClick={onResetPassword}
        >
          Reset Password
        </button>
      </div>
    </Popup>
  );
};

export default ProfilePopup;
